import type { BoggleGridSize } from '~/boggle/config/playground'
import type { BoggleChallengeCoreInfo } from './types'

export function getBoggleChallengeGridSizeInfo(gridSize: BoggleGridSize): BoggleChallengeCoreInfo<BoggleGridSize> {
  if (gridSize === '3x3') {
    return {
      id: 'small-grid',
      tierLabel: 'Small',
    }
  } else if (gridSize === '4x3') {
    return {
      id: 'medium-grid',
      tierLabel: 'Medium',
    }
  } else {
    return {
      id: 'large-grid',
      tierLabel: 'Large',
    }
  }
}
